// Important: These labels are stored in the database verbatim. Don't change them!

export enum ePermissionLevels {
  locked = 0,
  regular = 10,
  manager = 20,
  owner = 30,
}

export enum ePriceDisplayFormats {
  twoDecimal = 'twoDecimal',
  minDecimal = 'minDecimal',
}

export enum eTemperatures {
  cold = 'cold',
  room = 'room',
  hot = 'hot',
}

export enum eOptionTypes {
  other = 'other',
  size = 'size',
  topping = 'topping',
  side = 'side',
}

export enum eWeekdays {
  sunday = 'sunday',
  monday = 'monday',
  tuesday = 'tuesday',
  wednesday = 'wednesday',
  thursday = 'thursday',
  friday = 'friday',
  saturday = 'saturday',
}

export enum eMeasurementUnits {
  g = 'g',
  ml = 'ml',
}

export enum eSnackBarTypes {
  error = 'error',
  warning = 'warning',
  notice = 'notice',
  success = 'success',
}

export enum eAttributeSelectionTypes {
  unselected = 0,
  positive = 1,
  negative = 2,
}

export enum eOrderTypes {
  tableside = 'tableside',
  delivery = 'delivery',
  takeout = 'takeout',
}

export enum eNotificationTypes {
  tablesideOrder = 'tablesideOrder',
  takeoutOrder = 'takeoutOrder',
  deliveryOrder = 'deliveryOrder',
  request = 'request',
  cancellationRequest = 'cancellationRequest',
  feedback = 'feedback',
  question = 'question',
  bill = 'bill',
  payment = 'payment',
  tablesideOrderAdd = 'tablesideOrderAdd',
  tablesideOrderRemoval = 'tablesideOrderRemoval',
  quantityLowered = 'quantityLowered',
  quantityIncreased = 'quantityIncreased',
  tablesidePostOrderPayment = 'tablesidePostOrderPayment',
}

export enum eOrderStatuses {
  pending = 'pending',
  accepted = 'accepted',
  rejected = 'rejected',
  // Tableside specific
  cancelled = 'cancelled',
  // Delivery specific
  dispatched = 'dispatched',
  delivered = 'delivered',
  // Take out specific
  readyForPickUp = 'readyForPickUp',
  pickedUp = 'pickedUp',
}

export enum eNotificationStatuses {
  pending = 'pending',
  accepted = 'accepted',
  rejected = 'rejected',
  paused = 'paused',
  cancelled = 'cancelled',
  // When an order is changed by the staff
  privileged = 'privileged',
  // Delivery specific
  dispatched = 'dispatched',
  // Takeout specific
  readyForPickUp = 'readyForPickUp',
}

export enum ePushDesinations {
  user = 'user',
  establishment = 'establishment',
}

export enum eAppModes {
  tableside = 'tableside',
  takeout = 'takeout',
  viewOnly = 'viewOnly',
  delivery = 'delivery',
}

export enum eChargeStatuses {
  completed = 'completed',
  cancelled = 'cancelled',
}

// The following are used on the client side only. Can be changed.

export enum eBillTypes {
  full,
  partial,
  split,
}

export enum eFeatureFlagTypes {
  off,
  test,
  demo,
  prod,
}

export enum eNotificationDirection {
  sent,
  received,
}
